var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.313,
    height: 22,
    viewBox: "0 0 21.313 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2260.912,3159.17l-9.969-9.969a.687.687,0,0,0-.972,0L2240,3159.17a.687.687,0,0,0,.972.972l1.233-1.233v10.028a2.068,2.068,0,0,0,2.062,2.063h12.375a2.068,2.068,0,0,0,2.063-2.062v-10.028l1.233,1.233a.687.687,0,0,0,.972-.972Zm-12.517,10.455v-7.562h4.125v7.563Zm8.938-.687a.69.69,0,0,1-.687.688h-2.75v-8.25a.688.688,0,0,0-.687-.687h-5.5a.688.688,0,0,0-.687.688v8.25h-2.75a.69.69,0,0,1-.687-.687v-11.4l6.875-6.875,6.875,6.875Z",
    transform: "translate(-2239.8 -3149)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.709232fdeec9136af3e298e74b422e6a.svg";
export { ForwardRef as ReactComponent };